import type { Control, FieldValues } from 'react-hook-form';
import { DevTool } from '@hookform/devtools';

interface LocalHookFormDevtoolProps<T extends FieldValues = FieldValues> {
  control?: Control<T>;
}
export const LocalHookFormDevtool = <T extends FieldValues = FieldValues>({
  control
}: LocalHookFormDevtoolProps<T>) => {
  const isLocalEnvironment = window.location.hostname === 'localhost';
  if (isLocalEnvironment) {
    return <DevTool control={control} />;
  }
  return null;
};
